import React, { FC } from 'react';
import { useLastLoadByOrganizationLocation } from '../../../../api/queries/use-last-load-by-organization-location';
import { Step2CreateLoadFromPrevious } from './step-2-create-load-from-previous';
import { Button, CircularProgress } from '@mui/material';
import { L } from 'harmony-language';

interface Step2CreatePreviousProps {
    selectedOrganizationLocationId: number;
    onBack: () => void;
    onSubmit: () => void;
}

export const Step2CreatePrevious: FC<Step2CreatePreviousProps> = (props) => {
    const { selectedOrganizationLocationId, onBack, onSubmit } = props;
    const lastLoadByOrganizationLocationQuery = useLastLoadByOrganizationLocation(selectedOrganizationLocationId);

    return (
        lastLoadByOrganizationLocationQuery.isSuccess ? (
            !lastLoadByOrganizationLocationQuery.data ? (
                <>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={onBack}
                    >
                        {L.back()}
                    </Button>
                    <div>{L.locationNoHistory()}</div>
                </>
            ) : (
                <Step2CreateLoadFromPrevious
                    load={lastLoadByOrganizationLocationQuery.data}
                    onBack={onBack}
                    onSubmit={onSubmit}
                />
            )
        ) : <div style={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></div>
    );
};
